import { NavigationItem } from "../models";
import { RoutePaths } from "./route-paths";
import { Icons, UserType } from "../enums";
import { T } from "./translation-keys";

export const NAVIGATION_ITEMS: Array<NavigationItem> = [
  {
    label: T.DASHBOARD,
    path: RoutePaths.Dashboard,
    icon: Icons.Dashboard,
  },
  {
    label: T.PARTNERS,
    path: RoutePaths.Partners,
    icon: Icons.Partnership,
    accessedUserTypes: [UserType.SuperAdmin, UserType.Admin],
  },
  {
    label: T.BUSINESSES,
    path: RoutePaths.Businesses,
    icon: Icons.EditBusiness,
    accessedUserTypes: [UserType.Admin, UserType.SuperAdmin],
  },
  {
    label: T.BUSINESS_SETTINGS,
    path: RoutePaths.BusinessSettings,
    icon: Icons.BusinessSettings,
    accessedUserTypes: [UserType.Partner],
    redirectById: true,
  },
  {
    label: T.MANAGERS,
    path: RoutePaths.Managers,
    icon: Icons.Manager,
    accessedUserTypes: [UserType.SuperAdmin, UserType.Admin, UserType.Partner],
  },
  {
    label: T.BETSHOPS,
    path: RoutePaths.Betshops,
    icon: Icons.Betshop,
  },
  {
    label: T.SUB_MANAGERS,
    path: RoutePaths.Managers,
    icon: Icons.Manager,
    accessedUserTypes: [UserType.Manager],
  },
  {
    label: T.CASHIERS,
    path: RoutePaths.Cashiers,
    icon: Icons.Users,
  },
  {
    label: T.JACKPOTS,
    path: RoutePaths.Jackpots,
    icon: Icons.Jackpot,
  },
  {
    label: T.BET_HISTORY,
    path: RoutePaths.BetHistory,
    icon: Icons.BetHistory,
  },
  {
    label: T.GAMES_CONTROL,
    path: RoutePaths.GameControl,
    icon: Icons.GamesControl,
  },
  {
    label: T.TRANSACTION_HISTORY,
    path: RoutePaths.Transactions,
    icon: Icons.TransactionHistory,
  },
  {
    label: T.CONFIGURATIONS,
    path: RoutePaths.Configurations,
    icon: Icons.Configurations,
    accessedUserTypes: [UserType.SuperAdmin, UserType.Admin, UserType.Partner],
  },
  {
    label: T.REPORTS,
    path: '',
    icon: Icons.Assignment,
    sub: [
      {
        label: T.ANALYTICS,
        icon: Icons.Reports,
        path: RoutePaths.ReportAnalytics,
      },
      {
        icon: Icons.Charts,
        label: T.REPORTING_CHARTS,
        path: RoutePaths.ReportCharts,
      }
    ],
  },
];
